module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, _vm._l((_vm.campaignList), function(campaign, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "md6": "",
        "sm12": "",
        "lg4": ""
      }
    }, [_c('v-card', {
      staticStyle: {
        "min-height": "170px"
      },
      attrs: {
        "color": "#363636",
        "dark": ""
      }
    }, [_c('v-card-title', {
      staticStyle: {
        "font-size": "23px"
      }
    }, [_vm._v(_vm._s(campaign.name))]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-5"
    }, [_c('div', {
      staticClass: "text-right"
    }, [_c('v-btn', {
      attrs: {
        "to": '/reports/campaign/summary?id=' + campaign.id,
        "target": "_blank",
        "color": "warning",
        "right": ""
      }
    }, [_vm._v("View HTML Report")])], 1)])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e61a2f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignReport.vue
// module id = 2091
// module chunks = 0